module.exports = __webpack_public_path__ + "img/client.c5d9e430.png";